module.exports = __webpack_public_path__ + "img/bracelet.a2219253.png";